import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { UploadDocumentParameters, UploadDocumentParametersFormBuilder } from '../../models/UploadDocumentParameters';

@Component({
  selector: 'app-set-uploaded-document-description',
  templateUrl: './set-uploaded-document-description.component.html',
  styleUrls: ['./set-uploaded-document-description.component.scss']
})
export class SetUploadedDocumentDescriptionComponent extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef,
      private fb: UntypedFormBuilder,
    private formUtilsService: FormUtilsService,
    private uiNotification: UiNotificationService) {
    super(dialog);
  }

  @Input() uploadDocumentParameters: UploadDocumentParameters;

    documentDataForm: UntypedFormGroup;

  ngOnInit(): void {
    this.documentDataForm = UploadDocumentParametersFormBuilder.getFormForDescription(this.fb, this.uploadDocumentParameters);
  }

  confirm() {

  if(!this.formUtilsService.markFormGroupTouched(this.documentDataForm)) {
    this.uiNotification.showValidationError();
  return;
}

Object.assign(this.uploadDocumentParameters, this.documentDataForm.value);

this.dialog.close({ uploadDocumentParameters: this.uploadDocumentParameters });
  }
}